import { useRecordContext } from "ra-core";
import { formatPhoneLine } from "@/lib/dialCodes";

import type { PhoneNumberAndType } from "../types";

export function PhoneNumberText() {
  const phone = useRecordContext<PhoneNumberAndType>();
  if (!phone) {
    return null;
  }
  return <span>{formatPhoneLine(phone)}</span>;
}
